import { BIButton, globalTheme } from '@pulsepointinc/bi-components';
import styled from 'styled-components';

export const StyledLinkedFilterWrapper = styled.div`
  width: 100%;
  display: block;
`;

export const StyledIconWrapper = styled.div`
  margin-right: 4px;
  display: inline-flex;
  align-items: center;
`;

export const StyledAddParameterButton = styled(BIButton)`
  color: ${globalTheme.colors.textPrimary};
  letter-spacing: 0.2px;
`;
